import { useMemo } from "react";
import RoundedContainer from "./nav-rounded-container";
import "./screen-points.less";

interface Props {
  points: number
  pointsFormatter: (points: number) => string
  invisible?: boolean
  visible?: boolean
  invisibleClass?: string
}

export default function ScreenPoints(props: Props) {
  const { points, invisible, pointsFormatter, invisibleClass, visible } = props;
  const normalPointsText = useMemo(function() {
    return pointsFormatter(points);
  }, [points, pointsFormatter])
  
  let isVisible = true
  if (typeof invisible === "boolean" && !invisible)
    isVisible = false
  if (typeof visible === "boolean")
    isVisible = visible
  

  return <RoundedContainer 
    className="screen-points" 
    visible={isVisible} 
    invisibleClass={invisibleClass}
  >
    <div className="points-small" draggable={false}>{points}</div>
    <div className="points-normal" draggable={false}>{normalPointsText}</div>
  </RoundedContainer>
}